import { useTranslation } from 'react-i18next';
import { classes } from '../../../utils/commonUtils';

import styles from './link-modal.module.scss';

interface LinkModalCheckboxProps {
  handleCheckmark: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
}

export function LinkModalCheckbox({ handleCheckmark, checked }: LinkModalCheckboxProps) {
  const { t } = useTranslation();

  return (
    <label className={styles.checkboxContainer}>
      <div className={styles.labelText}> {t('dont show this message again')} </div>
      <input onChange={handleCheckmark} checked={checked} type="checkbox" />
      <span className={styles.checkmark}>
        <div className={classes('aib-icon', styles.icon, checked && styles.checked)}>v</div>
      </span>
    </label>
  );
}
